import { render, staticRenderFns } from "./chartCapex.vue?vue&type=template&id=3af6e2cc&"
import script from "./chartCapex.vue?vue&type=script&lang=js&"
export * from "./chartCapex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports